import { API } from 'services/apiResource';
import apiServices from 'services/apiServices';
import { notificationSuccess } from './Notification';
import { getAccounts } from './Accounts';
import { EventName } from '@jumbo/constants/electron/EventName';
import handleRequest from 'helpers/handleRequest';
import { fetchStart, fetchSuccess } from './Common';
import {
    GET_GROUPS,
    ADD_SELECTED_GROUP,
    CLOSE_MODIFY_POPUP_GROUP,
    OPEN_MODIFY_POPUP_GROUP,
    CLOSE_ADD_ACCOUNT_POPUP_GROUP,
    OPEN_ADD_ACCOUNT_POPUP_GROUP,
    RELOAD_SELECTED_GROUP,
    SET_DATA_SYNC_GROUP
} from '@jumbo/constants/ActionTypes';
const { ipcRenderer } = window.require('electron');

export const getGroups = () => {
    return async dispatch => {
        handleRequest(async () => {
            dispatch(fetchStart());
            let { rows, error } = await apiServices.get(API.GROUPS.getGroups);
            if (!rows) {
                throw error;
            }
            return rows;
        }, rows => {
            dispatch(fetchSuccess());
            dispatch({
                type: GET_GROUPS,
                payload: rows,
            });
        }, dispatch);
    };
};

export const createGroup = data => {
    return async dispatch => {
        handleRequest(async () => {
            dispatch(fetchStart());
            let { msg, error } = await apiServices.post(API.GROUPS.createGroup, data);
            if (!msg) {
                throw error;
            }
        }, () => {
            dispatch(fetchSuccess());
            dispatch(getGroups());
            dispatch(notificationSuccess('Tạo thành công nhóm !'));
        }, dispatch);
    };
};

export const updateGroup = (data, id) => {
    return async dispatch => {
        handleRequest(async () => {
            dispatch(fetchStart());
            let { msg, error } = await apiServices.put(`${API.GROUPS.updateGroup}/${id}`, data);
            if (!msg) {
                throw error;
            };
        }, () => {
            dispatch(fetchSuccess());
            dispatch(getGroups());
            dispatch(notificationSuccess('Cập nhật thành công nhóm !'));
        }, dispatch)
    };
};

export const deleteGroup = data => {
    return async dispatch => {
        handleRequest(async () => {
            dispatch(fetchStart());
            let { msg, error } = await apiServices.delete(`${API.GROUPS.deleteGroup}`, data);
            if (!msg) {
                throw error;
            }
        }, () => {
            dispatch(reloadSelectedGroup());
            dispatch(fetchSuccess());
            dispatch(getGroups());
            dispatch(notificationSuccess('Xóa thành công nhóm!'));
        }, dispatch);
    };
};
export const addAccountToGroup = (data, id) => {
    return async dispatch => {
        handleRequest(async () => {
            dispatch(fetchStart());
            let { msg, error } = await apiServices.put(`${API.GROUPS.addAccountToGroup}/${id}`, data);
            if (!msg) {
                throw error;
            }
        }, () => {
            dispatch(fetchSuccess());
            dispatch(getGroups());
            dispatch(getAccounts());
            dispatch(notificationSuccess('Thêm tài khoản vào nhóm thành công!'));
        }, dispatch);
    };
};
export const addSelectedGroup = data => {
    return dispatch => {
        dispatch({ type: ADD_SELECTED_GROUP, payload: data });
    };
};
export const reloadSelectedGroup = () => {
    return dispatch => {
        dispatch({ type: RELOAD_SELECTED_GROUP })
    }
}
export const closeModifyPopupGroup = () => {
    return { type: CLOSE_MODIFY_POPUP_GROUP };
};
export const openModifyPopupGroup = () => {
    return { type: OPEN_MODIFY_POPUP_GROUP };
};
export const closeAddAccountPopupGroup = () => {
    return { type: CLOSE_ADD_ACCOUNT_POPUP_GROUP };
};
export const openAddAccountPopupGroup = () => {
    return { type: OPEN_ADD_ACCOUNT_POPUP_GROUP };
};
export const removeAccountsGroup = (data) => {
    return async dispatch => {
        handleRequest(async () => {
            dispatch(fetchStart());
            let { msg, error } = await apiServices.post(`${API.ACCOUNTS.removeAccountsGroup}`, data);
            if (!msg) {
                throw error;
            }
        }, () => {
            dispatch(fetchSuccess());
            dispatch(getGroups());
            dispatch(getAccounts());
            dispatch(closeModifyPopupGroup());
            dispatch(notificationSuccess('Xóa tài khoản nhóm thành công!'));
        }, dispatch);
    };
};

export const listenSyncGroup = () => {
    return dispatch => {
        ipcRenderer.on(EventName.dataSyncGroup, (event, data) => {
            dispatch({ type: SET_DATA_SYNC_GROUP, payload: data })
        })
    }
}
